import { api } from 'app/api';

export const getConsentFile = async (params) => {
  return await api.get(`/dfd/api/if/web/v1/hsptlz-form-consent-file-info`, {
    params,
  });
};
